import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SkuPriceComponent } from './sku-price.component';

const routes: Routes = [
  {
    path: '',
    component: SkuPriceComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SkuPriceRoutingModule {}
